/**
 * Never, ever, ever, EVER try to access segment as anything except window.analytics. Storing it as
 * `const segment = window.analytics` will fuck your life up fucking royally
 */

const routeTitles = {
    "home": "Home",
    "about": "About",
    "faq": "FAQs",
    "tos": "Terms of Service",
    'privacy': 'Privacy Policy',
    "wall": "Wall of Love",
    "generating": "Generating",
    "generateByKeyword": "Generate By Keyword",
    "loadExisting": "Loading Results",
    "results": "Results",
    "recharge": "Recharge",
    "rechargeWithPackage": "Recharge With Package",
    "notFound": "Not Found"

};

export default {
    state: {
    },
    getters: {
    },

    mutations: {},

    actions: {
      pageLoaded(state, route)
      {
          const name = routeTitles[route.name];
          const params = route.params;
          window.analytics.page(name, {params});

          state.dispatch("updateChatPath", {title: name, url: window.location.href, name: route.name});
      },

      identifyUser(state, details) {
          const traits = {
              createdAt: details.created_at,
          };

          window.analytics.identify(details.customer_id, traits);

          state.dispatch("addChatTag", `Customer Id: ${details.customer_id}`);
      }
    },

}